import script from "./TpDocsTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TpDocsTabPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__